import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import heroImage from '@/assets/svg/hero.svg';
import { buttonVariants } from '@/components/app/button';
import { cn } from '@/lib/utils';

function Hero() {
	const { t } = useTranslation();

	return (
		<section className="bg-sky-50/40 px-4 py-12 [clip-path:polygon(100%_0,100%_92%,15%_100%,0_94%,0_0)]">
			<h1 className="mt-2 mb-6 text-balance text-center capitalize lg:mt-4 lg:mb-8">
				{t('home.hero.heading')}
			</h1>
			<p className="text-center text-ash-700">{t('home.hero.subheading')}</p>
			{<img src={heroImage} alt="A girl working out" className="mx-auto w-full max-w-80" />}
			<div className="mt-12 flex flex-wrap items-center justify-center gap-x-12 gap-y-6 p-4">
				<Link to="/login" className={cn(buttonVariants({ variant: 'default', size: 'lg' }))}>
					{t('home.hero.actionButton')}
				</Link>
				{/* <Button variant="outline" className="">
          {t('home.hero.alternateOptionButton')}
        </Button> */}
			</div>
		</section>
	);
}

export { Hero };
